import React from 'react';

import { ResizableBlock } from './ResizableBlock';

export default ({ config, editorProps }) => WrappedComponent => props => (
    <ResizableBlock {...props} {...editorProps} config={config} component={WrappedComponent} />
);
